import React from "react";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import formStyles from "@components/counterparty/CounterpartyForm.module.scss";

interface Props {
    formId?: string;
    submitLabel: string;
    isSubmitting: boolean;
    onCancel: () => void;
}

// Sticky footer for the counterparty editor when it renders inside a Modal
// (create and edit flows). Submits the associated form by id, reflects save
// progress, and disables Cancel while the write is in flight.
export const CounterpartyEditorModalFooter: React.FC<Props> = ({
    formId,
    submitLabel,
    isSubmitting,
    onCancel,
}) => (
    <footer className={formStyles.footer}>
        <Button
            type="button"
            variant="secondary"
            size="md"
            onClick={onCancel}
            disabled={isSubmitting}
        >
            Cancel
        </Button>
        <ButtonWithLoader
            type="submit"
            form={formId}
            loading={isSubmitting}
            variant="primary"
            size="md"
            hotKey="mod+enter"
            hotKeyDisplayPosition="inline"
            hotKeyOptions={{
                description: submitLabel,
                preventDefault: true,
                enableOnFormTags: true,
            }}
        >
            {submitLabel}
        </ButtonWithLoader>
    </footer>
);
